module.exports = __webpack_public_path__ + "static/media/trend.901ed01f.svg";